import type { HTMLAttributes, ReactNode } from "react";

function cx(...classes: Array<string | undefined | false>): string {
  return classes.filter(Boolean).join(" ");
}

export function SacredCard({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement> & { children: ReactNode }) {
  return (
    <div className={cx("card-sacred", className)} {...props}>
      {children}
    </div>
  );
}
